<template>
<v-dialog v-model="dialog" width="1280px">
  <v-card>
    <!-- <v-card-text style="height: 800px;"> -->
    <v-card-text>  
      <draggable
        :list="huis.hsft"
        :disabled="!enabled"
        class="list-group pt-4"
        ghost-class="ghost"
        @start="dragging = true"
        @end="dragging = false"
      >
        <div
          class="d-inline-flex ma-2"  
          v-for="element in huis.hsft"
          :key="element.hsft_nr"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <img :src="element.hsft_foto" :alt="element.fttgtaal_oms">
              </div>
            </template>
            <span>{{ element.fttgtaal_oms }}</span>
          </v-tooltip>
        </div>
      </draggable>
    </v-card-text>
    <v-card-actions>
      {{huis.huis_summer_winter}} photos
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveHsft">Save</v-btn>
      <v-btn color="primary" small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import draggable from 'vuedraggable';
// import {bus} from "../../../main";

export default {
  name: "simple",
  display: "Simple",
  order: 0,
  components: {
    draggable
  },
  data() {
    return {
      dialog: false,  
      enabled: true,
      huis_encrid: null,
      dragging: false,
      huis: {}
    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  methods: {
    open(huis_encrid,summer_winter) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hsft/getHuisToOrderHsft.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToOrderHsft"
          },
          getHuisToOrderHsft: {
            huis_encrid: huis_encrid,
            summer_winter: summer_winter
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.getHuisToOrderHsft;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveHsft() {
      this.saveHsftValid =  false;
      this.$axios
        .post("ares/json/ares/huis/hsft/saveHsft.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHsft"
          },
          saveHsft: {
            huis_encrid: this.huis.huis_encrid,
            huis_summer_winter: this.huis.huis_summer_winter,
            hsft: this.huis.hsft
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            //  if (res.data.saveHsft.color == "success") {
            //     //this.$router.reload('/huis/onHuis/' + res.data.saveHsft.huis_encrid);  
            //     bus.$emit("closeDialog", "reload");
            //  }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHsft.text,
              color: res.data.saveHsft.color
            }); 
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    }
  }
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.hsft-oms{
  margin-top: -10px;
}
</style>
